import { FC, useMemo } from "react";
import { Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay } from "@chakra-ui/react";
import { useCandidateIds } from "../CandidatePage/CandidateIdsContext";
import { useRequests } from "../../api";
import { RequestForm } from "./RequestForm";
import { Request } from "@am-tax/wotc-common";

interface RequestModalProps {
    isOpen: boolean;
    onClose: () => void;
    requestId: string | undefined;
}

export const RequestModal: FC<RequestModalProps> = ({ isOpen, onClose, requestId }) => {
    const { cId, eId, candidateId } = useCandidateIds();
    const engagementRequestsQuery = useRequests(cId, eId, candidateId);
    const request: Request | undefined = useMemo(
        () => engagementRequestsQuery.data?.find(request => request.id === requestId),
        [engagementRequestsQuery.data, requestId]
    );

    return (
        <Modal isOpen={isOpen} onClose={onClose} size={"xl"}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>{`${request?.id ? "Edit" : "Add"} Request`}</ModalHeader>
                <ModalCloseButton />
                <ModalBody pb={"1.5rem"}>
                    <RequestForm onClose={onClose} requestId={requestId} />
                </ModalBody>
            </ModalContent>
        </Modal>
    );
};
